import script from "./AIChat.vue?vue&type=script&lang=ts&setup=true"
export * from "./AIChat.vue?vue&type=script&lang=ts&setup=true"

import "./AIChat.vue?vue&type=style&index=0&id=744f2220&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-744f2220"]])

export default __exports__